import { ChangeDetectorRef, Component, Inject, OnInit, ViewChild } from "@angular/core";
import { FormBuilder, FormControl, FormGroup, Validators } from "@angular/forms";
import { MatCalendar, MatCalendarCellClassFunction, MatCalendarCellCssClasses } from "@angular/material/datepicker";
import { MAT_DIALOG_DATA, MatDialog, MatDialogRef } from "@angular/material/dialog";
import { MatMenuTrigger } from "@angular/material/menu";
import moment from "moment";
import { DynamicFilterService } from "src/app/components/shared/dynamic-filter/dynamic-filter.service";
import { DynamicPopupComponent } from "src/app/components/shared/dynamic-popup/dynamic-popup.component";
import { ScheduleFromDateToDateDialogComponent } from "src/app/components/shared/schedule-fromdate-todate/schedule-fromdate-todate.component";
import { DialogService } from "src/app/services/dialog.service";

@Component({
    selector: "app-emailconfigmodify",
    templateUrl: "./emailconfigmodify.component.html",
    styleUrls: ["./emailconfigmodify.component.scss"]
})

export class EmailModifyDialogComponent implements OnInit {

    scheduledDate: FormControl = new FormControl();
    beforeFormattedDate: any;
    selectedData: any;
    isLoading: boolean = false;
    keyOrder:any;
    fromTimeSlots: any[] = [];
    toTimeSlots: any[] = [];
    today: moment.Moment = moment().startOf('day'); 
    scheduleForm!: FormGroup;
    isSameDate: boolean = false;
    
    @ViewChild('fromCalendar') fromCalendar!: MatCalendar<Date>;
    @ViewChild('toCalendar') toCalendar!: MatCalendar<Date>;
    @ViewChild('fromTimeMenuTrigger') fromTimeMenuTrigger!: MatMenuTrigger;
    @ViewChild('toTimeMenuTrigger') toTimeMenuTrigger!: MatMenuTrigger;

    constructor(public dialogRef: MatDialogRef<EmailModifyDialogComponent>,
        @Inject(MAT_DIALOG_DATA) public data: any,
        private cdr: ChangeDetectorRef,
        private dialogService: DialogService,
        private dynamicFilterService: DynamicFilterService,
        private dialog: MatDialog,
         private fb: FormBuilder,

    ) {
        this.selectedData = data.details;
        this.beforeFormattedDate =data.scheduledDate;
    }


    ngOnInit() {
         this.scheduleForm = new FormGroup({
              fromDate: this.fb.control(null, Validators.required),
              fromTime: this.fb.control('', Validators.required),
              toDate: this.fb.control(null, Validators.required),
              toTime: this.fb.control('', Validators.required),
            });
            if(this.dynamicFilterService.selectedEndPointDetails == "api/file-processing-chevron/insert-manual-file-data") {
                this.keyOrder = ['Source', 'File key', 'File Name', 'Process Type']
            } else {
                this. keyOrder = ['Report Key', 'Report Type', 'From Email Group', 'To Email Group']
            }
        
            this.generateFromTimeSlots();
            this.generateToTimeSlots();
            console.log("this.data 64", this.data);
            if(this.data.endDateTime) this.isSameDate = true;
            if (this.data?.startDateTime || this.data.endDateTime ) {
              this.patchScheduleData(this.data.startDateTime, this.data.endDateTime );
            }
    }

    

    closeDialog(event: any) {

        const start_time_timestamp = moment(this.scheduleForm.get('fromDate')?.value).isValid() ? `${moment(this.scheduleForm.get('fromDate')?.value).format("MM-DD-YYYY")} ${this.scheduleForm.get('fromTime')?.value}` : '';
        const expected_end_date = moment(this.scheduleForm.get('toDate')?.value).isValid() ? `${moment(this.scheduleForm.get('toDate')?.value).format("MM-DD-YYYY")} ${this.scheduleForm.get('toTime')?.value}` : '';
        const payload = {
            ...this.data.payload,
            scheduled_date: `${start_time_timestamp}, ${expected_end_date}`,
            start_time_timestamp,
            expected_end_date
          };
        console.log(event);
        if(event == true) {
            this.isLoading = true;
            this.dynamicFilterService. postUnifiedDetailsModification(payload)
            .subscribe({
                next: (response) => {
                    console.log(response);
                    this.isLoading = false;
                    let msg ={ // `The ${this.dynamicFilterService.selectedProcessDetailsKey.sub_process_name} has been successfully ${this.data.type}.`
                        message: `Success! ${this.dynamicFilterService.selectedProcessDetailsKey.sub_process_name} is ${this.data.type}.`,
                        title: 'Success!',
                        icon: 'check_circle',
                        iconColor: '#3AC97c',
                        confirmText: 'Ok'
                      }
                      this.alertPopUp(msg).subscribe((data: any) => {
                        // Now this will execute **after** popup is closed
                        this.dialogRef.close();
                      });
                },
                error: (error) => {
                    this.isLoading = false;
                    console.log(error);
                }
            })
        } else  {
            this.dialogRef.close();
        }

    }

    alertPopUp(msg:any) {
        let dialogRef = this.dialog.open(DynamicPopupComponent, {
          maxWidth: "90vw",
          disableClose: true,
          panelClass: "du-custom-modalbox",
          data: {
            title: msg.title,
            message: msg.message,
            icon: msg.icon , // Use relevant icons
            iconColor:  msg.iconColor,
            // cancelText: 'Cancel',
            confirmText:  msg.confirmText,
          },
        });
        return dialogRef.afterClosed();
      }

      patchScheduleData(startDate: string, toDate: string): void {
        console.log("startDate", startDate, "toDate", toDate);
      
        const extractDateTime = (dateTime: string) => {
          const date = moment(dateTime); // Handles ISO 8601 automatically
          return {
            date: date.isValid() ? date.toDate() : null,
            time: date.isValid() ? date.format("HH:mm") : ""
          };
        };
      
        const startDateTime = extractDateTime(startDate);
        const toDateTime = extractDateTime(toDate);
      
        if (startDateTime && toDateTime) {
          this.scheduleForm.patchValue({
            fromDate: startDateTime.date,
            fromTime: this.fromTimeSlots.length > 0 ? startDateTime.time : '',
            toDate: toDateTime.date,
            toTime: '',
          });
      
          this.generateToTimeSlots();
      
          if (this.toTimeSlots.length > 0) {
            this.scheduleForm.get('toTime')?.patchValue(toDateTime.time);
          }
      
          this.cdr.detectChanges();
        }
      }
      

    generateFromTimeSlots(): void {
        const now = new Date();
        const start = new Date();
        start.setHours(0, 0, 0, 0);
        const end = new Date();
        end.setHours(23, 59, 59, 999);
    
        const interval = 15; // 15-minute interval
        const times = [];
        let current = start;
    
        while (current <= end) {
          const hours = current.getHours();
          const minutes = current.getMinutes();
          const period = hours >= 12 ? 'PM' : 'AM';
          const formattedHours = hours % 12 || 12; // Convert to 12-hour format
          const formattedMinutes = minutes.toString().padStart(2, '0');
          const timeLabel = `${formattedHours}:${formattedMinutes} ${period}`;
          // Include AM/PM in timeValue for the 12-hour format
          const timeValue = `${formattedHours.toString().padStart(2, '0')}:${formattedMinutes} ${period}`;
          const selectedDt = moment(this.scheduleForm.get('fromDate')?.value, 'MM/DD/YYYY');
          const isPast = selectedDt.isSame(moment(now), 'day') && current < now;
          times.push({ label: timeLabel, value: timeValue, disabled: isPast });
          current.setMinutes(current.getMinutes() + interval);
        }
    
        this.fromTimeSlots = times;
      }
    
      generateToTimeSlots(): void {
        if (!this.scheduleForm.get('toDate')?.value || !this.scheduleForm.get('fromTime')?.value) {
          return;
        }
    
        const now = new Date();
        const start = new Date();
        start.setHours(0, 0, 0, 0);
        const end = new Date();
        end.setHours(23, 59, 59, 999);
    
        const interval = 15; // 15-minute interval
        const times = [];
        let current = start;
    
        const selectedFromMoment = moment(this.scheduleForm.get('fromTime')?.value, 'hh:mm A');
    
        while (current <= end) {
          const hours = current.getHours();
          const minutes = current.getMinutes();
          const period = hours >= 12 ? 'PM' : 'AM';
          const formattedHours = hours % 12 || 12;
          const formattedMinutes = minutes.toString().padStart(2, '0');
          const timeLabel = `${formattedHours}:${formattedMinutes} ${period}`;
          const timeValue = `${formattedHours.toString().padStart(2, '0')}:${formattedMinutes} ${period}`;
    
          const selectedToMoment = moment(timeValue, 'hh:mm A');
          let fromDate = this.scheduleForm.get('fromDate')?.value
          let toDate = this.scheduleForm.get('toDate')?.value
          const isSameDate = fromDate && toDate && moment(fromDate).isSame(toDate, 'day');
          const isDisabled = (isSameDate && selectedToMoment.isBefore(selectedFromMoment)) ||
            (moment(toDate).isSame(moment(now), 'day') && current < now);
    
          times.push({ label: timeLabel, value: timeValue, disabled: isDisabled });
          current.setMinutes(current.getMinutes() + interval);
        }
    
        this.toTimeSlots = times;
        this.cdr.detectChanges(); // ✅ Ensure UI updates
      }

    onFromTimeChange(): void {
        if (this.scheduleForm.get('fromDate')?.value && this.scheduleForm.get('toDate')?.value && moment(this.scheduleForm.get('fromDate')?.value).isSame(this.scheduleForm.get('toDate')?.value, 'day')) {
          this.scheduleForm.get('toTime')?.setValue('');
          this.toTimeSlots = [];
          this.generateToTimeSlots();
        }
    
        this.cdr.detectChanges();
      }
    
      selectFromDate(event: any): void {
        this.generateFromTimeSlots();
        this.cdr.detectChanges();
    
        this.fromTimeMenuTrigger.openMenu();
      }
    
    
    
      selectToDate(event: any): void {
        this.generateToTimeSlots();
        this.toTimeMenuTrigger.openMenu();
        this.cdr.detectChanges();
      }
    
      isFromDateSelected: MatCalendarCellClassFunction<Date> = (date: Date): MatCalendarCellCssClasses => {
        if (!this.scheduleForm.get('fromDate')?.value) return '';
    
        const isSelected = this.scheduleForm.get('fromDate')?.value && moment(date).isSame(this.scheduleForm.get('fromDate')?.value, 'day');
        return isSelected ? 'fromDateSelected' : '';
      };
    
      isToDateSelected: MatCalendarCellClassFunction<Date> = (date: Date): MatCalendarCellCssClasses => {
        if (!this.scheduleForm.get('toDate')?.value) return '';
    
        const isSelected = this.scheduleForm.get('toDate')?.value && moment(date).isSame(this.scheduleForm.get('toDate')?.value, 'day');
        return isSelected ? 'toDateSelected' : '';
      };
    
      isDisabled = (date: Date): boolean => {
        const momentDate = moment(date).startOf('day');
        if (momentDate.isBefore(this.today)) {
          return true;
        }
        return false;
      };
    
      // dateFilterFrom = (date: Date | null): boolean => {
      //   if (!date) return false;
      //   const momentDate = moment(date).startOf('day');
      //   return !momentDate.isBefore(this.today);
      // };
    
      dateFilterFrom = (date: Date | null): boolean => {
        if (!date) return false;
        const momentDate = moment(date).startOf('day');
        return !momentDate.isBefore(this.today); // Only allow dates that are today or in the future
      };
    
    
    
      dateFilterTo = (date: Date | null): boolean => {
        if (!date) return false;
        const momentDate = moment(date).startOf('day');
        
        const today = moment().startOf('day');
        const maxDate = today.clone().add(1, 'year'); // One year from today

        if (momentDate.isBefore(this.today)) return false;
        if (this.scheduleForm.get('fromDate')?.value && momentDate.isBefore(moment(this.scheduleForm.get('fromDate')?.value), 'day')) return false;

        // Rule 3: Date cannot be more than 1 year from today
        if  (momentDate.isAfter(maxDate)) return false;
    
        return true;
      };
    
      setCurrentTime(type:any) {
        const now = new Date();
        //this.scheduleForm.get('fromDate')?.setValue(new Date(now.toISOString().split('T')[0]));
        let minutes = now.getMinutes();
        let roundedMinutes = Math.round(minutes / 15) * 15;
    
        if (roundedMinutes === 60) {
          now.setHours(now.getHours() + 1);
          roundedMinutes = 0;
        }
    
        let hours = now.getHours();
        const period = hours >= 12 ? 'PM' : 'AM';
        const formattedHours = (hours % 12 || 12).toString().padStart(2, '0');
        const formattedTime = `${formattedHours}:${roundedMinutes.toString().padStart(2, '0')} ${period}`;
    
        setTimeout(() => {
          
          if(type== 'from') {
            this.scheduleForm.get('fromDate')?.setValue(new Date(now.toISOString().split('T')[0]));
            this.scheduleForm.get('fromTime')?.setValue(formattedTime)
          } else {
            this.scheduleForm.get('toDate')?.setValue(new Date(now.toISOString().split('T')[0]));
            this.scheduleForm.get('toTime')?.setValue(formattedTime); 
          }
        //   type === 'from' ? this.scheduleForm.get('fromTime')?.setValue(formattedTime) : this.scheduleForm.get('toTime')?.setValue(formattedTime);  
        //   this.scheduleForm.get('fromTime')?.setValue(formattedTime);
          this.cdr.detectChanges();
        });
      }
    
      get fromDateTimeDisplay(): string {
        const date = this.scheduleForm.get('fromDate')?.value;
        const time = this.scheduleForm.get('fromTime')?.value;
      
        // const formattedDate = date
        //   ? new Intl.DateTimeFormat('en-GB', { day: '2-digit', month: '2-digit', year: 'numeric' }).format(new Date(date))
        //   : '';
        const formattedDate = date ? moment(date).format('MM-DD-YYYY') : '';
      
        return (formattedDate && time) ? `${formattedDate} ${time}` : formattedDate || time || '';
      }  
      
    
      onTimeOptionSelected(time: any): void {
        console.log("Time option selected:", time);
        
        this.scheduleForm.patchValue({
          fromTime: time.value
        }); // Important!\
        console.log(this.scheduleForm.value);
      }
      
      get toDateTimeDisplay(): string {
        const date = this.scheduleForm.get('toDate')?.value;
        const time = this.scheduleForm.get('toTime')?.value;
      
        const formattedDate = date ? moment(date).format('MM-DD-YYYY') : '';
      
        return (formattedDate && time) ? `${formattedDate} ${time}` : formattedDate || time || '';
      }
    
      onToTimeSelected(time: { label: string; value: string }) {
        this.scheduleForm.patchValue({ toTime: time.value });
      }
}